module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/icon_wavy-line-green-aaf25ccd91a39f30a1819729a59a5318.svg";